<script setup lang="ts">
  const items = [
    {
      id: 'caf-banner',
      image: '/images/lo-hp-new/caf-art-desktop.webp',
      title: 'Challenge friends',
      lead: 'This social feature allows players to add friends, create private game rooms, and compete head-to-head.',
      imageClasses: 'max-w-[17.5rem] desktop-1660:max-w-[28.75rem] bottom-0 right-0 desktop-1660:-right-5',
      contentClasses: 'max-w-[55%]',
    },
    {
      id: 'raf-banner',
      image: '/images/lo-hp-new/raf-image-desktop.webp',
      title: 'Refer a Friend',
      lead: 'Bring your friends to the MaxDuel platform and earn extra rewards. The more friends you refer, the more benefits you can unlock!',
      imageClasses: 'max-w-[12rem] desktop-1660:max-w-[20rem] bottom-1/2 translate-y-1/2 right-4',
      contentClasses: 'max-w-[60%] desktop-1660:max-w-1/2',
    },
  ];
</script>

<template>
  <UCarousel
    v-slot="{ item }"
    :items="items"
    align="start"
    dots
    loop
    :ui="{
      viewport: 'h-full',
      container: 'h-full',
      item: 'self-stretch',
      controls: 'absolute inset-x-0 h-2 bottom-10',
      dots: 'justify-start bottom-0 gap-1 left-10',
      dot: 'size-1 transition-all bg-white/50 data-[state=active]:bg-white data-[state=active]:w-10',
    }"
    class="aspect-[716/372]"
  >
    <div
      class="relative h-full grid w-full bg-gradient-to-r from-[#0874bf] via-[#0257a5] to-[#053a8d] p-6 desktop-1660:p-10 rounded-lg overflow-hidden"
    >
      <div class="text-white text-left flex flex-col gap-6" :class="item.contentClasses">
        <h4 class="font-barlow text-5xl desktop-1660:text-[3.9375rem] font-extrabold leading-none uppercase">
          {{ item.title }}
        </h4>
        <p class="font-barlow text-base desktop-1660:text-xl font-medium leading-[135%] tracking-[0.3px]">
          {{ item.lead }}
        </p>
      </div>
      <NuxtImg
        class="absolute"
        :src="item.image"
        :alt="item.title"
        :class="item.imageClasses"
        preload
        densities="x1 x2"
      />
    </div>
  </UCarousel>
</template>
